import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import MenuIcon from '@material-ui/icons/Menu'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import Title from '../../components/Title'
import Card from '@material-ui/core/Card'
import { getMenu, isMobile } from '../../utils'
import CardContent from '@material-ui/core/CardContent'
import { Col, Row } from 'antd'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'
import { withSnackbar } from 'notistack'
import { useDeepEffect } from '../../utils/hooks'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { HERO_TYPE } from '../../utils/constants'
import { useDispatch } from 'react-redux'
import { getHeroMe, saveHeroSetting } from '../../stores/hero'

const styles = (theme) => ({
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869'
      }
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none'
    }
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  iOSIcon: {
    width: 24,
    height: 24
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1]
  }
})

export const HeroSetting = ({ me, ToggleDrawer, classes, enqueueSnackbar }) => {
  const dispatch = useDispatch()
  const [checked, setChecked] = useState(false)
  const [open, setOpen] = useState(false)

  useDeepEffect(() => {
    setChecked(me.active)
  }, [])

  const handleChange = async (e) => {
    await setChecked(e.target.checked)
    await setOpen(true)
  }

  const onClose = async () => {
    await setOpen(false)
    await setChecked(me.active)
  }

  const onOk = async () => {
    const data = {
      active: checked,
      heroId: me.id
    }
    await dispatch(saveHeroSetting(data, enqueueSnackbar))
    await dispatch(getHeroMe())
  }

  function getStatusActive() {
    if (me.heroType === HERO_TYPE.CIRCULAR_BIN) {
      return `เปิดรับวัสดุรีไซเคิลเพื่อให้ Circular Bin ของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    } else {
      return `เปิดรับซื้อวัสดุรีไซเคิลเพื่อให้ร้านของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    }
  }

  function getStatusClose() {
    if (me.heroType === HERO_TYPE.CIRCULAR_BIN) {
      return `ปิดรับวัสดุรีไซเคิลเพื่อให้ Circular Bin ของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    } else {
      return `ปิดรับซื้อวัสดุรีไซเคิลเพื่อให้ร้านของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    }
  }

  function getModalActiveText() {
    if (me.heroType === HERO_TYPE.CIRCULAR_BIN) {
      return `คุณยืนยันจะเปิดรับวัสดุรีไซเคิลเพื่อให้ Circular Bin ของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    } else {
      return `คุณยืนยันจะเปิดรับซื้อวัสดุรีไซเคิลเพื่อให้ร้านของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    }
  }

  function getModalCloseText() {
    if (me.heroType === HERO_TYPE.CIRCULAR_BIN) {
      return `คุณยืนยันจะปิดรับวัสดุรีไซเคิลเพื่อให้ Circular Bin ของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    } else {
      return `คุณยืนยันจะปิดรับซื้อวัสดุรีไซเคิลเพื่อให้ร้านของคุณไม่แสดงบนแอพพลิเคชั่น Green2Get`
    }
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnMenu"
            color="inherit"
            aria-label="Menu"
            onClick={() => ToggleDrawer()}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" color="inherit">
            {getMenu(me.heroType)}
          </Typography>
        </Toolbar>
      </AppBar>
      <Title name={getMenu(me.heroType)} />
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContent>
          <Row>
            <Col span={12}>
              <Typography variant="h6" style={{ color: '#6ebf95' }}>
                {getMenu(me.heroType)}
              </Typography>
            </Col>
            <Col span={12}>
              <Row justify="end">
                <Switch
                  classes={{
                    switchBase: classes.iOSSwitchBase,
                    bar: classes.iOSBar,
                    icon: classes.iOSIcon,
                    iconChecked: classes.iOSIconChecked,
                    checked: classes.iOSChecked
                  }}
                  checked={checked}
                  onChange={handleChange}
                  value="checkedA"
                />
              </Row>
            </Col>
          </Row>
          {me.active ? (
            <Typography variant="subtitle1" style={{ color: '#000' }}>
              {getStatusActive()}
            </Typography>
          ) : (
            <Typography variant="subtitle1" style={{ color: '#000' }}>
              {getStatusClose()}
            </Typography>
          )}
        </CardContent>
      </Card>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">ยืนยัน</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {!checked ? (
              <span>{getModalCloseText()}</span>
            ) : (
              <span>{getModalActiveText()}</span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()} color="primary">
            ยกเลิก
          </Button>
          <Button onClick={() => onOk()} color="primary" autoFocus>
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

HeroSetting.propTypes = {
  ToggleDrawer: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withSnackbar
)(withStyles(styles)(HeroSetting))



// WEBPACK FOOTER //
// ./src/pages/HeroSetting/index.js